import type { QueryClient } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";

/**
 * The signed-in employee (`GET /api/admin/auth/session`), through the query cache. The `_admin` layout
 * route ensures it before any admin page loads; a 401 there sends the browser to `/login`.
 */
export const sessionQuery = () => orpc.session.current.queryOptions({ retry: false, staleTime: 60_000 });

/** After sign-out, or when the server says the session ended: nothing cached may outlive it. */
export const forgetSession = (queryClient: QueryClient) => queryClient.clear();

/**
 * Where to go after signing in: the `redirect` search parameter if it is a path on this site,
 * otherwise the Start page. Anything else (`//evil.example`, `https://...`) would be an open redirect.
 */
export function safeRedirect(target: string | undefined): string {
	if (!target?.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) return "/";
	return target;
}
